import { useNavigate } from 'react-router-dom'

// styles
import { SecondaryBtnContainer } from './SecondaryBtn.styles.js'

export default function SecondaryBtn({ isDisabled = false, title, route = null, onClick = null, type = 'default' }) {
  const navigate = useNavigate()

  const handleAction = () => {
    if (onClick) {
      onClick()
    } else if (route) {
      navigate(route)
    }
  }

  return (
    <SecondaryBtnContainer
      className={"panel-bg"}
      onClick={handleAction}
      disabled={isDisabled}
      $type={type}
    >
      {title}
    </SecondaryBtnContainer>
  )
}